let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cW6Dc")).then(() => parcelRequire('9MIqa'));